import {createSelector} from 'reselect';

const getUIState = state => state.ui;

export const getActivePicksTab = createSelector(getUIState, ({activePicksTab = null}) => activePicksTab);
